import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import CalendarNewEvent from './CalendarNewEvent';

loadDOMComponent({
	selector: 'react-calendar-new-event',
	callback: ({ container, context }: any) => {
		const patientId = container.getAttribute('patientId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<CalendarNewEvent patientId={patientId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
